import { IconUser, IconCheck, IconX } from "@tabler/icons-react";

export const dynamicColor = (color?: string) => {
  return color ? `text-${color}` : undefined;
};

export const avatarWithTwoLines = (avatar: string, line_1: string, line_2: string) => {
  return (
    <div className="d-flex py-1 align-items-center">
      <span
        className="avatar me-2"
        style={
          avatar
            ? {
                backgroundImage: `url(${avatar})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
              }
            : undefined
        }
      >
        {!avatar && <IconUser />}
      </span>
      <div className="flex-fill">{twoLines(line_1, line_2)}</div>
    </div>
  );
};

export const twoLines = (line_1: string, line_2: string) => {
  return (
    <>
      {oneLine(line_1)}
      {mutedLine(line_2)}
    </>
  );
};

export const oneLine = (line: string, color?: string, styles?: React.CSSProperties) => {
  return (
    <div className={dynamicColor(color)} style={styles}>
      {line}
    </div>
  );
};

export const mutedLine = (line: string) => {
  return <div className="text-muted">{line}</div>;
};

export const linkLine = (link: string) => {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {link}
    </a>
  );
};

export const checkOrXIcon = (value: boolean) => {
  return value ? <IconCheck className="icon text-primary" /> : <IconX className="icon text-danger" />;
};

export const tagsList = (tags: string[], colors?: string[]) => {
  return (
    <div className="tags-list">
      {tags.map((tag, index) => (
        <span className={`tag ${colors && colors[index] ? `border-${colors[index]}` : ""}`} key={index}>
          {tag}
        </span>
      ))}
    </div>
  );
};
